<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ damages?: { id: number; file_url: string; description: string }[]; loading?: boolean }>()

const damageImgSrcList = computed(() => props.damages?.map((damage: any) => damage.file_url) ?? [])
</script>

<template>
  <el-card v-loading="loading">
    <div class="flex flex-col gap-6">
      <h4>Damages</h4>
      <div v-if="damages?.length" class="max-h-[600px] flex flex-col gap-4 overflow-auto">
        <div v-for="(damage, index) in damages" :key="damage.id" class="flex flex-col gap-3">
          <el-image
            :src="damage.file_url"
            fit="cover"
            class="h-[198px] rounded-lg"
            :preview-src-list="damageImgSrcList"
            :initial-index="index"
            :alt="damage.description"
          />
          <p>{{ damage.description }}</p>
        </div>
      </div>
      <div v-else-if="!loading">
        <p class="component-label text-tertiary">No damages.</p>
      </div>
    </div>
  </el-card>
</template>
